import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form-mui';
import RenderSelectField from '../../../../Utilities/Forms/RenderSelectField';
import RenderTextField from '../../../../Utilities/Forms/RenderTextField';
import ValidatedSelectElement from '../../../../Utilities/Forms/ValidatedSelectElement';
import ValidatedTextField from '../../../../Utilities/Forms/ValidatedTextField';
import monthDropdown from '../../../../Utilities/Constants/MonthDropdown';
import yesNoDropdown from '../../../../Utilities/Constants/YesNoDropdown';
interface IProps {
    isReadOnly: boolean
}
export default function TravelPlanCyclingV1({ isReadOnly }: IProps) {

    const { getValues } = useFormContext();
    const formValues = getValues();
    const hasValues = (fields: string[]) => fields.some(field => formValues[field]) || !isReadOnly;

    return (
        <>
            <Grid container alignItems="flex-start">
                <Grid size={4} container>
                    {hasValues(["coveredCycleRacksCloseToBuildingEnterance", "coveredCycleRacksCloseToBuildingEnteranceMonth", "coveredCycleRacksCloseToBuildingEnteranceYear", "coveredCycleRacksCloseToBuildingEnteranceCapitalCost", "coveredCycleRacksCloseToBuildingEnteranceAnnulaCost"]) && (
                        <Grid container size={12} >
                            <RenderSelectField name="coveredCycleRacksCloseToBuildingEnterance" label="Covered cycle racks close to building enterances" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'coveredCycleRacksCloseToBuildingEnteranceMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'coveredCycleRacksCloseToBuildingEnteranceYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="coveredCycleRacksCloseToBuildingEnteranceCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="coveredCycleRacksCloseToBuildingEnteranceAnnulaCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}

                    {hasValues(["lockersAndFacilitiesForStaffCycling", "lockersAndFacilitiesForStaffCyclingMonth", "lockersAndFacilitiesForStaffCyclingYear", "lockersAndFacilitiesForStaffCyclingCapitalCost", "lockersAndFacilitiesForStaffCyclingAnnualCost"]) && (
                        <Grid container size={12} >
                            <RenderSelectField name="lockersAndFacilitiesForStaffCycling" label="Lockers/Facilities for staff who cycle to store their clothing" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'lockersAndFacilitiesForStaffCyclingMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'lockersAndFacilitiesForStaffCyclingYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="lockersAndFacilitiesForStaffCyclingCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="lockersAndFacilitiesForStaffCyclingAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}

                    {hasValues(["cctvCoverageOfCycleArea", "cctvCoverageOfCycleAreaMonth", "cctvCoverageOfCycleAreaYear", "cctvCoverageOfCycleAreaCapitalCost", "cctvCoverageOfCycleAreaAnnualCost"]) && (
                        <Grid container size={12} >
                            <RenderSelectField name="cctvCoverageOfCycleArea" label="CCTV coverage of cycle parking areas" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'cctvCoverageOfCycleAreaMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'cctvCoverageOfCycleAreaYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="cctvCoverageOfCycleAreaCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="cctvCoverageOfCycleAreaAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    {hasValues(["goodNetworkOfCycleRoutesLinkedToSite", "goodNetworkOfCycleRoutesLinkedToSiteMonth", "goodNetworkOfCycleRoutesLinkedToSiteYear", "goodNetworkOfCycleRoutesLinkedToSiteCapitalCost", "goodNetworkOfCycleRoutesLinkedToSiteAnnualCost"]) && (
                        <Grid container size={12} >
                            <RenderSelectField name="goodNetworkOfCycleRoutesLinkedToSite" label="Good network of cycle routes linking the site to main residential areas locally" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'goodNetworkOfCycleRoutesLinkedToSiteMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'goodNetworkOfCycleRoutesLinkedToSiteYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="goodNetworkOfCycleRoutesLinkedToSiteCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="goodNetworkOfCycleRoutesLinkedToSiteAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}

                    {hasValues(["goodLightingInCycleParkingAreas", "goodLightingInCycleParkingAreasMonth", "goodLightingInCycleParkingAreasYear", "goodLightingInCycleParkingAreasCapitalCost", "goodLightingInCycleParkingAreasAnnualCost"]) && (
                        <Grid container size={12} >
                            <RenderSelectField name="goodLightingInCycleParkingAreas" label="Good lighting in cycle parking areas" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'goodLightingInCycleParkingAreasMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'goodLightingInCycleParkingAreasYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="goodLightingInCycleParkingAreasCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="goodLightingInCycleParkingAreasAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}

                    {hasValues(["secureWellLitOrCoveredCycleParking", "secureWellLitOrCoveredCycleParkingMonth", "secureWellLitOrCoveredCycleParkingYear", "secureWellLitOrCoveredCycleParkingCapitalCost", "secureWellLitOrCoveredCycleParkingAnnualCost"]) && (
                        <Grid container size={12} >
                            <RenderSelectField name="secureWellLitOrCoveredCycleParking" label="Secure well-lit/covered cycle parking compound" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'secureWellLitOrCoveredCycleParkingMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'secureWellLitOrCoveredCycleParkingYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="secureWellLitOrCoveredCycleParkingCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="secureWellLitOrCoveredCycleParkingAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}

                </Grid>

                <Grid size={4} container>
                    {hasValues(["showersAndChangingFacilitiesForStaff", "showersAndChangingFacilitiesForStaffMonth", "showersAndChangingFacilitiesForStaffYear", "showersAndChangingFacilitiesForStaffCapitalCost", "showersAndChangingFacilitiesForStaffAnnualCost"]) && (
                        <Grid container size={12} >
                            <RenderSelectField name="showersAndChangingFacilitiesForStaff" label="Shower and changing facilities for staff who cycle and walk" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'showersAndChangingFacilitiesForStaffMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'showersAndChangingFacilitiesForStaffYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="showersAndChangingFacilitiesForStaffCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="showersAndChangingFacilitiesForStaffAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}
                    <Grid container size={12} >
                        <Grid size={12}>
                            <Typography variant={"h6"}>Additional comments</Typography>
                        </Grid>
                        <RenderTextField name="cycleComments" readOnly={isReadOnly} multiLine={true} rows={4} inputSize={12} labelSize={12} alwaysShow={true} />
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
}
